// Queries
import futureDeliveryRequest from "./FutureDeliveryRequestQuery.gql";
import materialTypes from "./MaterialTypesQuery.gql";
import pastDueInvoiceInfo from "./PastDueInvoiceInfoQuery.gql";
import receiptLogs from "./ReceiptLogsSelectQuery.gql";

// Mutations
import addFutureDeliveryRequest from "./AddFutureDeliveryRequestMutation.gql";
import assignFutureDeliveryRequestToReceiptLogs from "./AssignFutureDeliveryRequestToReceiptLogs.gql";
import confirmFutureDeliveryRequest from "./ConfirmFutureDeliveryRequestMutation.gql";
import deleteFutureDeliveryRequest from "./DeleteFutureDeliveryRequestMutation.gql";
import updateFutureDeliveryRequest from "./UpdateFutureDeliveryRequestMutation.gql";

export const Query = {
    futureDeliveryRequest,
    materialTypes,
    receiptLogs,
    pastDueInvoiceInfo,
};

export const Mutation = {
    updateFutureDeliveryRequest,
    deleteFutureDeliveryRequest,
    confirmFutureDeliveryRequest,
    addFutureDeliveryRequest,
    assignFutureDeliveryRequestToReceiptLogs,
};
